import { z } from 'zod';

const RequiredActivitySchema = z.object({
  deadline: z.coerce.number().optional(),
});

export default RequiredActivitySchema;
